module.exports = __webpack_public_path__ + "static/media/memo.22af6052.svg";